 Vue.component('login-container', {
	template: 
		"<div class=\"formwrap\">" + 
			"<h3 v-if=\"showHeader\" class=\"blue\">Login to your account</h3>" + 
			"<form id=\"login\" ref=\"login\" @submit.prevent=\"loginSubmit\" name=\"login\" method=\"post\">" + 
				"<p class=\"error-permissions\">{{ errorMessage }}</p>" +
				"<label> Email <input type=\"text\" name=\"username\" id=\"username\" maxlength=\"50\" size=\"15\" value=\"\" required onfocus=\"formFocused = true;this.select();\" autofocus></label> " + 
				"<label> Password <input name=\"password\" id=\"password\" type=\"password\" maxlength=\"30\" size=\"15\" value=\"\" required onfocus=\"formFocused = true;this.select();\"></label> " +
				"<input type=\"hidden\" v-model=\"planContext\" name=\"planContext\" required>" +
				"<a class=\"reset-password\" href=\"reset-password\">Forgotten your Password?</a>" + 
				"<a class=\"login-controls\" id=\"loginButton\" href=\"javascript:$(\'#loginHiddenButton\').click();\" title=\"Login\">Login</a>" + 
				"<button type=\"submit\" id=\"loginHiddenButton\" style=\"display: none;\"></button>" + 
			"</form>" + 
		"</div>",
		data: function () {
		    return {
		    	action: "login-submit",
		    	errorMessage: "",
		    	planContext: "",
		    	showHeader: false,
			};
		},
		methods: {
			loginSubmit: function(){
				$.blockUI({ message: 'Loading. Please wait...',
					fadeIn: 0,
					css: {	border: 'none', 
							padding: '15px', 
							backgroundColor: '#000', 
							'-webkit-border-radius': '10px', 
							'-moz-border-radius': '10px',
							'border-radius': '10px',
							opacity: .5, 
							'font-weight': 'bold',
							'font-size': '13px',
							color: '#fff'
					}
				});
				this.$refs.login.action = this.action;
			    this.$refs.login.submit();
			}
		}
});

var login = new Vue ({
	el: '.login-container',
	methods: {
		setErrorMessage: function(text) {
			this.$refs.loginContainer.errorMessage = text;
		},
		setField: function (field, value) {
			this.$refs.loginContainer[field] = value;
		}
	}			
});